import {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {environment} from '@environments/environment';
import {TokenStoreService} from '@core/services/token/token-store.service';

const PUBLIC_API_PATHS = [
  '/api/auth/login',
  '/api/auth/signup',
  '/api/auth/refresh-token',
  '/api/auth/send-phone-otp',
  '/api/auth/verify-phone-otp',
  '/api/auth/forgot-password/send-otp',
  '/api/auth/forgot-password/send-email-link',
  '/api/auth/forgot-password/verify-otp',
  '/api/auth/reset-password',
  '/api/catalog',
  '/api/admin/auth/login',
  '/api/admin/auth/forgot-password/send-email-link',
  '/api/admin/auth/reset-password',
];

let isLoggingOut = false;

export const authErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const tokenStore = inject(TokenStoreService);

  return next(request).pipe(
    catchError((error: unknown) => {
      if (
        error instanceof HttpErrorResponse &&
        error.status === 401 &&
        tokenStore.isLoggedIn() &&
        !isPublicApiPath(request.url)
      ) {
        if (!isLoggingOut) {
          isLoggingOut = true;
          tokenStore.logout();
          isLoggingOut = false;
        }
      }

      return throwError(() => error);
    }),
  );
};

function isPublicApiPath(requestUrl: string): boolean {
  if (!requestUrl.startsWith(environment.baseUrl)) {
    return true;
  }

  const apiPath = requestUrl.slice(environment.baseUrl.length);
  return PUBLIC_API_PATHS.some((publicPath) => apiPath.startsWith(publicPath));
}
